var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "alerts-list-container" },
    [
      _c("p", { staticClass: "alert-title" }, [
        _vm._v(_vm._s(_setup.texts.alerts)),
      ]),
      _setup.ListStatus.OK === _setup.status
        ? _c(
            "v-list",
            { staticClass: "alert-list" },
            _vm._l(_setup.alertsMessagesList, function (alert, index) {
              return _c(_setup.AlertListItemComponent, {
                key: index,
                attrs: { alert: alert },
              })
            }),
            1
          )
        : _vm._e(),
      _setup.ListStatus.EMPTY === _setup.status
        ? _c("section", { staticClass: "no-data-container" }, [
            _c("span", {
              class: [_setup.icon.noData, "lf-icon__xl", "no-data-icon"],
            }),
            _c(
              "div",
              { staticClass: "texts" },
              [
                _c("p", { staticClass: "no-data-text" }, [
                  _vm._v(_vm._s(_setup.texts.noData)),
                ]),
                _c("i18n", {
                  staticClass: "link-text",
                  attrs: { path: _setup.path, tag: "div" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "link",
                        fn: function () {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "actions-link",
                                attrs: { to: _setup.alertConfigPanelURL },
                              },
                              [_vm._v(_vm._s(_setup.texts.link))]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    493502959
                  ),
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _setup.ListStatus.ERROR === _setup.status
        ? _c("section", { staticClass: "no-data-container" }, [
            _c("span", {
              class: [_setup.icon.error, "lf-icon__xl", "no-data-icon"],
            }),
            _c("div", { staticClass: "texts" }, [
              _c("p", { staticClass: "no-data-text" }, [
                _vm._v(_vm._s(_setup.texts.loadError)),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(_setup.LfLabelButtonComponent, {
        staticClass: "alerts-btn",
        attrs: {
          disabled: !_setup.alertsMessagesList.length,
          text: _setup.texts.viewMoreAlerts,
          action: () => _setup.goToAlertsMessagesView(),
          variant: _setup.LabelButtonVariant.OUTLINED,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }